export function createExternalId() {
  return Math.random().toString(36).substring(2, 15) + new Date().getTime().toString(36);
}

export function isFeatureEnabled(featureName: string, features: any[]) {
  return features.findIndex((feature) => feature.name === featureName) !== -1;
}
